/**
 * Gift Wrap Functionality for Shopify Cart
 * Handles gift wrapping options for cart items
 */

(function() {
    'use strict';

  function formatMoney(cents, currency) {
      const amount = cents / 100;

      return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0 
      }).format(amount);
  }
  
    // Global variables for gift wrap product info (declared first)
    let giftWrapProductId = null;
    let giftWrapProductHandle = null;
    let giftWrapProductImage = null;
    let giftWrapProductDescription = null;
    let giftWrapVariants = [];
    
    // Flag to prevent infinite refresh loops
    let isRefreshingCart = false;
  
    // Initialize gift wrap product ID from modal if available
    function initializeGiftWrapProductId() {
      const modal = document.getElementById('gift-wrap-modal');
      if (modal) {
        giftWrapProductId = modal.getAttribute('data-gift-wrap-product-id');
        giftWrapProductHandle = modal.getAttribute('data-gift-wrap-product-handle');
        giftWrapProductImage = modal.getAttribute('data-gift-wrap-product-image');
        giftWrapProductDescription = modal.getAttribute('data-gift-wrap-product-description');
      }
    }
  
    /**
     * Get current selected currency from currency switcher
     */
    // function getSelectedCurrency() {
    //   // Try to get from currency switcher select element
    //   const currencySelect = document.getElementById('currencies');
    //   if (currencySelect && currencySelect.value) {
    //     return currencySelect.value.toUpperCase();
    //   }
      
    //   // Try to get from custom select element (cs-select)
    //   const csSelect = document.querySelector('.cs-select');
    //   if (csSelect) {
    //     const selectedOption = csSelect.querySelector('option[selected]') || csSelect.querySelector('option:checked');
    //     if (selectedOption && selectedOption.value) {
    //       return selectedOption.value.toUpperCase();
    //     }
    //     // Try to get from the select element itself if it's visible
    //     if (csSelect.tagName === 'SELECT' && csSelect.value) {
    //       return csSelect.value.toUpperCase();
    //     }
    //   }
      
    //   // Try to get from CurrencySelector__Select class
    //   const currencySelector = document.querySelector('.CurrencySelector__Select');
    //   if (currencySelector && currencySelector.value) {
    //     return currencySelector.value.toUpperCase();
    //   }
      
    //   // Try to get from localStorage (currency switcher might store it there)
    //   try {
    //     const storedCurrency = localStorage.getItem('currency');
    //     if (storedCurrency) {
    //       return storedCurrency.toUpperCase();
    //     }
    //   } catch (e) {
    //     // localStorage not available
    //   }
      
    //   return null;
    // }
  
    /**
     * Get currency symbol from currency code
     */
    // function getCurrencySymbol(currencyCode) {
    //   const currencySymbols = {
    //     'GBP': '£',
    //     'USD': '$',
    //     'EUR': '€',
    //     'CAD': '$',
    //     'AUD': '$',
    //     'JPY': '¥',
    //     'CNY': '¥',
    //     'INR': '₹',
    //     'RUB': '₽',
    //     'BRL': 'R$',
    //     'KRW': '₩',
    //     'MXN': '$',
    //     'SGD': 'S$',
    //     'HKD': 'HK$',
    //     'NZD': '$',
    //     'ZAR': 'R',
    //     'CHF': 'CHF',
    //     'SEK': 'kr',
    //     'NOK': 'kr',
    //     'DKK': 'kr',
    //     'PLN': 'zł',
    //     'TRY': '₺',
    //     'THB': '฿',
    //     'ILS': '₪',
    //     'AED': 'د.إ',
    //     'SAR': '﷼',
    //     'PKR': '₨',
    //     'BGN': 'лв',
    //     'HUF': 'Ft',
    //     'CZK': 'Kč',
    //     'RON': 'lei',
    //     'PHP': '₱',
    //     'MYR': 'RM',
    //     'IDR': 'Rp',
    //     'VND': '₫',
    //     'EGP': '£',
    //     'ARS': '$',
    //     'CLP': '$',
    //     'COP': '$',
    //     'PEN': 'S/',
    //     'UYU': '$U',
    //     'BOB': 'Bs.',
    //     'PYG': '₲',
    //     'CRC': '₡',
    //     'GTQ': 'Q',
    //     'HNL': 'L',
    //     'NIO': 'C$',
    //     'PAB': 'B/.',
    //     'DOP': 'RD$',
    //     'JMD': 'J$',
    //     'BBD': 'Bds$',
    //     'BZD': 'BZ$',
    //     'TTD': 'TT$',
    //     'XCD': '$',
    //     'AWG': 'ƒ',
    //     'ANG': 'ƒ',
    //     'SRD': '$',
    //     'GYD': 'G$',
    //     'BWP': 'P',
    //     'ZMW': 'ZK',
    //     'MZN': 'MT',
    //     'MGA': 'Ar',
    //     'ETB': 'Br',
    //     'KES': 'KSh',
    //     'TZS': 'TSh',
    //     'UGX': 'USh',
    //     'RWF': 'RF',
    //     'XOF': 'CFA',
    //     'XAF': 'FCFA',
    //     'NGN': '₦',
    //     'GHS': '₵',
    //     'SLL': 'Le',
    //     'LRD': 'L$',
    //     'GMD': 'D',
    //     'GNF': 'FG',
    //     'MAD': 'د.م.',
    //     'TND': 'د.ت',
    //     'DZD': 'د.ج',
    //     'LYD': 'ل.د',
    //     'SDG': 'ج.س.',
    //     'SSP': '£',
    //     'ERN': 'Nfk',
    //     'DJF': 'Fdj',
    //     'SOS': 'Sh.So.',
    //     'KMF': 'CF',
    //     'MUR': '₨',
    //     'SCR': '₨',
    //     'MVR': 'Rf',
    //     'LKR': '₨',
    //     'BDT': '৳',
    //     'MMK': 'K',
    //     'KHR': '៛',
    //     'LAK': '₭',
    //     'BND': 'B$',
    //     'KZT': '₸',
    //     'KGS': 'сом',
    //     'TJS': 'ЅМ',
    //     'TMT': 'm',
    //     'UZS': 'so\'m',
    //     'AFN': '؋',
    //     'IRR': '﷼',
    //     'IQD': 'ع.د',
    //     'JOD': 'د.ا',
    //     'LBP': 'ل.ل',
    //     'SYP': '£',
    //     'YER': '﷼',
    //     'OMR': '﷼',
    //     'QAR': '﷼',
    //     'BHD': 'د.ب',
    //     'KWD': 'د.ك',
    //     'AZN': '₼',
    //     'AMD': '֏',
    //     'GEL': '₾',
    //     'BYN': 'Br',
    //     'MDL': 'lei',
    //     'UAH': '₴',
    //     'RSD': 'дин.',
    //     'BAM': 'КМ',
    //     'MKD': 'ден',
    //     'ALL': 'Lek',
    //     'ISK': 'kr',
    //     'FJD': 'FJ$',
    //     'PGK': 'K',
    //     'SBD': 'SI$',
    //     'VUV': 'Vt',
    //     'XPF': 'F',
    //     'TOP': 'T$',
    //     'WST': 'WS$',
    //     'TVD': '$',
    //     'AOA': 'Kz',
    //     'ZWL': 'Z$',
    //     'MWK': 'MK',
    //     'LSL': 'L',
    //     'SZL': 'E',
    //     'NAD': 'N$',
    //     'TWD': 'NT$'
    //   };
      
    //   const code = currencyCode ? currencyCode.trim().toUpperCase() : 'GBP';
    //   return currencySymbols[code] || '£'; // Default to £ for GBP
    // }
    // const formattedPrice =totalGiftWrapPrice;
    let currencySymbol = "$";
   
    /**
     * Format price without decimals (removes all decimal parts including dot)
     * Adds thousand separators (commas) for better readability
     */
    // function formatPriceWithoutDecimals(priceInCents) {
    //   const price = priceInCents / 100;
    //   // Remove all decimal parts - always return integer
    //   const roundedPrice = Math.round(price);
    //   // Add thousand separators (commas) for all currencies
    //   return roundedPrice.toLocaleString('en-US');
    // }
  
    /**
     * Update gift wrap total in cart
     * This function is accessible globally within the module
     */
    function updateGiftWrapTotal(cart) {
      if (!cart || !cart.items) {
        console.warn('Cart data not available for gift wrap total calculation');
        return;
      }
  
      let totalGiftWrapPrice = 0;
      const giftWrapTotalLine = document.getElementById('gift-wrap-total-line');
      const giftWrapTotalAmount = document.querySelector('.gift-wrap-total-amount');
  
      // Calculate total from all gift wrap items (items from the gift wrap product)
      // Since gift wrap variants are now added as separate cart items
      if (cart.items && cart.items.length > 0 && giftWrapProductId) {
        cart.items.forEach(function(item) {
          // Check if this item is from the gift wrap product
          if (item.product_id == giftWrapProductId) {
            // Add this item's price to total (multiply by quantity)
            // item.price is in cents, so multiply by quantity
            totalGiftWrapPrice += item.price * item.quantity;
            console.log('Gift wrap item found:', item.title, 'Price:', item.price, 'Quantity:', item.quantity, 'Subtotal:', item.price * item.quantity);
          }
        });
      }
  
      console.log('Total gift wrap price:', totalGiftWrapPrice);
  
      // Update display
      if (giftWrapTotalLine && giftWrapTotalAmount) {
        if (totalGiftWrapPrice > 0) {
          
          
          // Get currency from switcher or cart
          let currencyCode = null;
          if (!currencyCode) {
            currencyCode = cart.currency || 'GBP';
          }
          currencyCode = currencyCode.toUpperCase();
          
          // Get currency symbol
          // const currencySymbol = getCurrencySymbol(currencyCode);
          
          // Display price with currency symbol
          giftWrapTotalAmount.innerHTML = formatMoney(totalGiftWrapPrice, cart.currency);
          
          // Also update the data attribute for currency conversion if needed
          if (cart.currency) {
            // giftWrapTotalAmount.setAttribute('data-currency-' + cart.currency, formattedPrice);
          }
          giftWrapTotalLine.style.display = 'flex';
        } else {
          giftWrapTotalLine.style.display = 'none';
          console.log('Gift wrap total line hidden (no gift wrap items)');
        }
      } else {
        console.warn('Gift wrap total elements not found');
      }
    }
  
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        // Initialize product ID first
        initializeGiftWrapProductId();
        initGiftWrap();
        // Update gift wrap total on page load
        setTimeout(function() {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              updateGiftWrapTotal(cart);
            })
            .catch(error => {
              console.error('Error loading cart for gift wrap total:', error);
            });
        }, 200);
      });
    } else {
      // DOM is already ready
      initializeGiftWrapProductId();
      initGiftWrap();
      // Update gift wrap total on page load
      setTimeout(function() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateGiftWrapTotal(cart);
          })
          .catch(error => {
            console.error('Error loading cart for gift wrap total:', error);
          });
      }, 200);
    }
  
    // Also re-initialize after cart updates (for AJAX cart updates)
    let cartUpdateTimeout = null;
        // Listen for cart refresh requests (e.g. after product removal when DOM removal fails)
    document.addEventListener('cart:request-refresh', function() {
      refreshCartHTML();
    });

    document.addEventListener('cart:updated', function() {
      // Skip if we're currently refreshing the cart to prevent infinite loops
      if (isRefreshingCart) {
        return;
      }
      
      // Debounce to prevent multiple initializations
      if (cartUpdateTimeout) {
        clearTimeout(cartUpdateTimeout);
      }
      
      cartUpdateTimeout = setTimeout(function() {
        initializeGiftWrapProductId();
        initGiftWrap();
        // Update gift wrap total on cart update
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateGiftWrapTotal(cart);
          })
          .catch(error => {
            console.error('Error loading cart for gift wrap total:', error);
          });
      }, 200);
    });
  
    function initGiftWrap() {
      const giftWrapCheckboxes = document.querySelectorAll('.gift-wrap-checkbox');
      const modal = document.getElementById('gift-wrap-modal');
      
      if (!modal) {
        console.warn('Gift wrap modal not found. Make sure the modal HTML is in the cart template.');
        return;
      }
      const closeModalBtn = document.querySelector('.gift-wrap-close-modal');
      const cancelBtn = document.querySelector('.gift-wrap-cancel-btn');
      const overlay = document.querySelector('.gift-wrap-modal-overlay');
      const form = document.getElementById('gift-wrap-form');
      
      let currentItemKey = null;
      let currentProductId = null;
      let currentVariantId = null;
  
      // Get gift wrap product ID, handle, image, and description from modal data attributes
      // (These are already set by initializeGiftWrapProductId, but update them here too in case modal was added dynamically)
      if (modal) {
        const modalProductId = modal.getAttribute('data-gift-wrap-product-id');
        const modalProductHandle = modal.getAttribute('data-gift-wrap-product-handle');
        const modalProductImage = modal.getAttribute('data-gift-wrap-product-image');
        const modalProductDescription = modal.getAttribute('data-gift-wrap-product-description');
        
        if (modalProductId) giftWrapProductId = modalProductId;
        if (modalProductHandle) giftWrapProductHandle = modalProductHandle;
        if (modalProductImage) giftWrapProductImage = modalProductImage;
        if (modalProductDescription) giftWrapProductDescription = modalProductDescription;
      }
  
      // Load gift wrap product variants
      if (giftWrapProductHandle || giftWrapProductId) {
        loadGiftWrapVariants(giftWrapProductHandle || giftWrapProductId);
      }
  
      // Event listeners for checkboxes
      giftWrapCheckboxes.forEach(function(checkbox) {
        // Remove old event listeners by cloning
        const newCheckbox = checkbox.cloneNode(true);
        checkbox.parentNode.replaceChild(newCheckbox, checkbox);
        
        newCheckbox.addEventListener('change', function(event) {
          const itemKey = event.target.getAttribute('data-item-key');
          const productId = event.target.getAttribute('data-product-id');
          const variantId = event.target.getAttribute('data-variant-id');
          
          currentItemKey = itemKey;
          currentProductId = productId;
          currentVariantId = variantId;
  
          if (event.target.checked) {
            console.log('Opening gift wrap modal for item:', itemKey);
            openGiftWrapModal(event.target);
          } else {
            console.log('Removing gift wrap for item:', itemKey);
            // Uncheck the checkbox immediately and prevent any re-checking
            const checkbox = event.target;
            checkbox.checked = false;
            checkbox.removeAttribute('checked');
            checkbox.removeAttribute('data-saved');
            
            // Hide gift wrap details immediately
            const detailsDiv = document.querySelector('.gift-wrap-details[data-item-key="' + itemKey + '"]');
            if (detailsDiv) {
              detailsDiv.style.display = 'none';
              detailsDiv.innerHTML = '';
            } 
            
            removeGiftWrap(itemKey, productId, variantId).then(function() {
              // Ensure checkbox stays unchecked after removal
              const checkCheckbox = document.querySelector('[data-item-key="' + itemKey + '"].gift-wrap-checkbox');
              if (checkCheckbox) {
                checkCheckbox.checked = false;
                checkCheckbox.removeAttribute('checked');
                checkCheckbox.removeAttribute('data-saved');
              }
            }).catch(function(error) {
              console.error('Error in removeGiftWrap:', error);
              // On error, keep checkbox unchecked since user wanted to remove
              const checkCheckbox = document.querySelector('[data-item-key="' + itemKey + '"].gift-wrap-checkbox');
              if (checkCheckbox) {
                checkCheckbox.checked = false;
                checkCheckbox.removeAttribute('checked');
              }
            });
          }
        });
      });
  
      // Close modal handlers
      if (closeModalBtn) {
        closeModalBtn.addEventListener('click', closeModal);
      }
  
      if (cancelBtn) {
        cancelBtn.addEventListener('click', closeModal);
      }
  
      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }
  
      // Form submission
      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          saveGiftWrapDetails();
        });
      }
  
      // Load existing gift wrap data when checkbox is checked on page load
      giftWrapCheckboxes.forEach(function(checkbox) {
        if (checkbox.checked) {
          const itemKey = checkbox.getAttribute('data-item-key');
          loadExistingGiftWrapData(itemKey, checkbox);
        }
      });
  
      // Calculate and display gift wrap total on page load
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateGiftWrapTotal(cart);
        })
        .catch(error => {
          console.error('Error loading cart for gift wrap total:', error);
        });
  
      // Listen for currency changes from currency switcher
      function setupCurrencyListener() {
        // Listen to currency select element with id="currencies"
        const currencySelect = document.getElementById('currencies');
        if (currencySelect) {
          currencySelect.addEventListener('change', function() {
            const selectedCurrency = this.value;
            console.log('Currency changed to:', selectedCurrency);
            
            // Update gift wrap price if modal is open
            const variantPriceEl = document.getElementById('gift-wrap-variant-price');
            if (variantPriceEl && variantPriceEl.style.display !== 'none') {
              // Update the currency code in data attribute
              variantPriceEl.setAttribute('data-currency-code', selectedCurrency);
              // Update the price display
              updateVariantPrice();
            }
          });
        }
        
        // Also listen to CurrencySelector__Select class (for theme's currency switcher)
        const currencySelectors = document.querySelectorAll('.CurrencySelector__Select');
        currencySelectors.forEach(function(selector) {
          selector.addEventListener('change', function() {
            const selectedCurrency = this.value;
            console.log('Currency changed to:', selectedCurrency);
            
            // Update gift wrap price if modal is open
            const variantPriceEl = document.getElementById('gift-wrap-variant-price');
            if (variantPriceEl && variantPriceEl.style.display !== 'none') {
              // Update the currency code in data attribute
              variantPriceEl.setAttribute('data-currency-code', selectedCurrency);
              // Update the price display
              updateVariantPrice();
            }
          });
        });
      }
      
      // Setup currency listener
      setupCurrencyListener();
      
      // Also setup listener after a delay to catch dynamically loaded currency switchers
      setTimeout(function() {
        setupCurrencyListener();
      }, 1000);
  
      /**
       * Load gift wrap product variants
       */
      function loadGiftWrapVariants(productIdentifier) {
        if (!productIdentifier) return;
  
        // Fetch product data from Shopify using handle (preferred) or ID
        // Shopify's .js endpoint uses product handle
        fetch('/products/' + productIdentifier + '.js')
          .then(response => {
            if (!response.ok) {
              throw new Error('Product not found');
            }
            return response.json();
          })
          .then(product => {
            giftWrapVariants = product.variants || [];
            populateVariantSelect();
          })
          .catch(error => {
            console.error('Error loading gift wrap product:', error);
            // If handle doesn't work and we have an ID, try alternative approach
            // Note: Shopify doesn't support fetching by ID via .js endpoint
            // So we'll need to use the handle from the section settings
            console.warn('Could not load gift wrap product. Please ensure the product handle is correct in theme settings.');
          });
      }
  
      /**
       * Populate variant select dropdown
       */
      function populateVariantSelect() {
        const variantSelect = document.getElementById('gift-wrap-variant-select');
        if (!variantSelect) return;
  
        // Clear all existing options
        while (variantSelect.options.length > 0) {
          variantSelect.remove(0);
        }
  
        // Add variants
        let firstAvailableVariant = null;
        giftWrapVariants.forEach(function(variant, index) {
          if (variant.available) {
            const option = document.createElement('option');
            option.value = variant.id;
            option.textContent = variant.title;
            option.setAttribute('data-price', variant.price);
            variantSelect.appendChild(option);
            
            // Store first available variant
            if (index === 0 || !firstAvailableVariant) {
              firstAvailableVariant = variant;
            }
          }
        });
  
        // Remove any existing change listeners by cloning
        const newVariantSelect = variantSelect.cloneNode(true);
        variantSelect.parentNode.replaceChild(newVariantSelect, variantSelect);
  
        // Select first available variant by default
        if (firstAvailableVariant && newVariantSelect.options.length > 0) {
          newVariantSelect.value = firstAvailableVariant.id;
          console.log('First variant selected by default:', firstAvailableVariant.id, firstAvailableVariant.title);
        }
  
        // Add change listener to show variant price and toggle form fields
        newVariantSelect.addEventListener('change', function() {
          console.log('Variant changed, updating price...');
          updateVariantPrice();
          toggleFormFieldsBasedOnVariant();
        });
        
        // Toggle form fields for initially selected variant
        setTimeout(function() {
          toggleFormFieldsBasedOnVariant();
        }, 50);
        
        // Update price display after variants are loaded and first variant is selected
        setTimeout(function() {
          updateVariantPrice();
        }, 50);
      }
  
      /**
       * Toggle form fields based on selected variant
       * Disables Receiver Name, Sender Name, and Message if variant is "Gift Wrap"
       */
      function toggleFormFieldsBasedOnVariant() {
        const variantSelect = document.getElementById('gift-wrap-variant-select');
        const receiverNameInput = document.getElementById('gift-wrap-receiver-name');
        const senderNameInput = document.getElementById('gift-wrap-sender-name');
        const messageTextarea = document.getElementById('gift-wrap-message');
        
        if (!variantSelect) {
          return;
        }
        
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (!selectedOption) {
          return;
        }
        
        // Get variant title (text content of the option)
        const variantTitle = selectedOption.textContent || '';
        const variantTitleLower = variantTitle.toLowerCase().trim();
        
        // Check if variant title is exactly "Gift Wrap" or contains "Gift Wrap" but not "Message"
        const isGiftWrapOnly = variantTitleLower === 'gift wrap' || 
                               (variantTitleLower.includes('gift wrap') && 
                                !variantTitleLower.includes('message'));
        
        // Disable/enable fields based on variant
        if (receiverNameInput) {
          receiverNameInput.disabled = isGiftWrapOnly;
          if (isGiftWrapOnly) {
            receiverNameInput.value = ''; // Clear value when disabled
            receiverNameInput.removeAttribute('required');
          } else {
            receiverNameInput.setAttribute('required', 'required');
          }
        }
        
        if (senderNameInput) {
          senderNameInput.disabled = isGiftWrapOnly;
          if (isGiftWrapOnly) {
            senderNameInput.value = ''; // Clear value when disabled
            senderNameInput.removeAttribute('required');
          } else {
            senderNameInput.setAttribute('required', 'required');
          }
        }
        
        if (messageTextarea) {
          messageTextarea.disabled = isGiftWrapOnly;
          if (isGiftWrapOnly) {
            messageTextarea.value = ''; // Clear value when disabled
          }
        }
        
        console.log('Form fields toggled. Variant:', variantTitle, 'Is Gift Wrap Only:', isGiftWrapOnly);
      }
  
      /**
       * Update variant price display
       */
      function updateVariantPrice() {
  const variantSelect = document.getElementById('gift-wrap-variant-select');
  const variantPriceEl = document.getElementById('gift-wrap-variant-price');

  if (!variantSelect || !variantPriceEl) return;

  const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  if (!selectedOption) return;

  const price = selectedOption.getAttribute('data-price');
  if (!price) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const currency = cart.currency || 'GBP';
      variantPriceEl.innerHTML = formatMoney(parseFloat(price), currency);
      variantPriceEl.style.display = 'block';
    })
    .catch(() => {
      variantPriceEl.innerHTML = formatMoney(parseFloat(price), 'GBP');
      variantPriceEl.style.display = 'block';
    });
}
  
      /**
       * Open gift wrap modal
       */
      function openGiftWrapModal(checkbox) {
        if (!modal) {
          console.error('Gift wrap modal not found');
          return;
        }
  
        // Populate modal with gift wrap product info
        const productImageEl = modal.querySelector('.gift-wrap-product-image');
        const productDescEl = modal.querySelector('.gift-wrap-product-description');
  
        // Show gift wrap product image (from schema settings), not cart item image
        if (productImageEl) {
          if (giftWrapProductImage) {
            productImageEl.src = giftWrapProductImage;
            productImageEl.alt = 'Gift Wrapping';
            productImageEl.style.display = 'block';
          } else {
            productImageEl.style.display = 'none';
          }
        }
        
        // Show gift wrap product description (from schema settings), not cart item description
        if (productDescEl) {
          productDescEl.textContent = giftWrapProductDescription || '';
        }
  
        // Reset form
        const form = document.getElementById('gift-wrap-form');
        if (form) {
          form.reset();
        }
  
        // Reset variant price display - will be updated when variants load
        const variantPriceEl = document.getElementById('gift-wrap-variant-price');
        if (variantPriceEl) {
          // Price will be set when variants are loaded and first variant is selected
          variantPriceEl.style.display = 'block';
          
          // Get currency from currency switcher first
          let currencyCode = null;
          
          // If not found from switcher, try data attribute
          if (!currencyCode) {
            currencyCode = variantPriceEl.getAttribute('data-currency-code');
          }
          
          // Validate currency code function
          function isValidCurrencyCode(code) {
            if (!code || typeof code !== 'string') return false;
            const trimmed = code.trim().toUpperCase();
            return /^[A-Z]{3}$/.test(trimmed) && trimmed !== 'CUR' && !trimmed.includes('DROP') && !trimmed.includes('CURRENCY');
          }
          
          // Validate the currency code
          if (currencyCode && !isValidCurrencyCode(currencyCode)) {
            console.warn('Invalid currency code:', currencyCode);
            currencyCode = null;
          }
          
          if (!currencyCode || !isValidCurrencyCode(currencyCode)) {
            // Fetch from cart as fallback
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                let fetchedCurrency = cart.currency;
                if (!fetchedCurrency || !isValidCurrencyCode(fetchedCurrency)) {
                  fetchedCurrency = window.Shopify?.shop?.currency || 'GBP';
                }
                currencyCode = fetchedCurrency.toUpperCase();
                variantPriceEl.setAttribute('data-currency-code', currencyCode);
                // Update initial price display with currency symbol if it doesn't have one
                const currentPrice = variantPriceEl.textContent.trim();
                // Check if price already has a currency symbol (simplified check)
                const hasSymbol = /^[£$€¥₹₽R\$S\$HK\$krлвFtKčleizł₺฿₪د\.إ﷼₨Bs\.QJ\$Bds\$BZ\$TT\$XCD\$ƒMTArBrKShTShUShRFCFA₦₵LeL\$D]/.test(currentPrice);
                if (currentPrice && !hasSymbol) {
                  // If price doesn't already have currency symbol, add it
                  const priceMatch = currentPrice.match(/^[\d.,]+/);
                  if (priceMatch) {
                    // const currencySymbol = getCurrencySymbol(currencyCode);
                    variantPriceEl.textContent = currencySymbol + priceMatch[0];
                  }
                }
              })
              .catch(error => {
                console.warn('Could not fetch cart for currency');
                currencyCode = 'GBP';
                variantPriceEl.setAttribute('data-currency-code', currencyCode);
              });
          } else {
            // Currency code exists and is valid, ensure initial price has symbol
            currencyCode = currencyCode.trim().toUpperCase();
            variantPriceEl.setAttribute('data-currency-code', currencyCode);
            const currentPrice = variantPriceEl.textContent.trim();
            // Check if price already has a currency symbol (simplified check)
            const hasSymbol = /^[£$€¥₹₽R\$S\$HK\$krлвFtKčleizł₺฿₪د\.إ﷼₨Bs\.QJ\$Bds\$BZ\$TT\$XCD\$ƒMTArBrKShTShUShRFCFA₦₵LeL\$D]/.test(currentPrice);
            if (currentPrice && !hasSymbol) {
              // If price doesn't already have currency symbol, add it
              const priceMatch = currentPrice.match(/^[\d.,]+/);
              if (priceMatch) {
                // const currencySymbol = getCurrencySymbol(currencyCode);
                variantPriceEl.textContent = currencySymbol + priceMatch[0];
              }
            }
          }
        }
  
        // Load existing gift wrap data if available
        const itemKey = checkbox.getAttribute('data-item-key');
        loadExistingGiftWrapData(itemKey, checkbox);
        
        // Re-attach variant price listener after modal opens
        // Wait a bit longer to ensure variants are loaded
        setTimeout(function() {
          const variantSelect = document.getElementById('gift-wrap-variant-select');
          if (variantSelect) {
            // If no variant is selected, select the first one
            if (!variantSelect.value || variantSelect.value === '') {
              if (variantSelect.options.length > 0) {
                variantSelect.value = variantSelect.options[0].value; // First variant
                console.log('Auto-selected first variant:', variantSelect.value);
              }
            }
            
            // Remove old listener and add new one
            const newSelect = variantSelect.cloneNode(true);
            variantSelect.parentNode.replaceChild(newSelect, variantSelect);
            
            // Make sure first variant is still selected after cloning
            if (!newSelect.value || newSelect.value === '') {
              if (newSelect.options.length > 0) {
                newSelect.value = newSelect.options[0].value;
              }
            }
            
            // Add change event listener to update price and toggle form fields when variant changes
            newSelect.addEventListener('change', function() {
              console.log('Variant select changed in modal');
              updateVariantPrice();
              toggleFormFieldsBasedOnVariant();
            });
            
            // Update price for selected variant (should be first variant by default)
            console.log('Updating price for selected variant:', newSelect.value);
            updateVariantPrice();
            toggleFormFieldsBasedOnVariant();
          } else {
            console.warn('Variant select not found when trying to attach listener');
          }
        }, 200);
  
        // Show modal
        modal.classList.add('active');
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
  
      /**
       * Load existing gift wrap data for an item
       */
      function loadExistingGiftWrapData(itemKey, checkbox) {
        // Get cart data to find existing properties
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const item = cart.items.find(function(cartItem) {
              return cartItem.key === itemKey;
            });
  
            if (item && item.properties) {
              const receiverNameInput = document.getElementById('gift-wrap-receiver-name');
              const senderNameInput = document.getElementById('gift-wrap-sender-name');
              const messageTextarea = document.getElementById('gift-wrap-message');
              const variantSelect = document.getElementById('gift-wrap-variant-select');
  
              // Populate form fields
              // Handle properties as array or object
              if (Array.isArray(item.properties)) {
                item.properties.forEach(function(prop) {
                  if (prop[0] === 'Receiver Name' && receiverNameInput) {
                    receiverNameInput.value = prop[1] || '';
                  } else if (prop[0] === 'Sender Name' && senderNameInput) {
                    senderNameInput.value = prop[1] || '';
                  } else if (prop[0] === 'Message' && messageTextarea) {
                    messageTextarea.value = prop[1] || '';
                  } else if (prop[0] === 'Gift Wrap Variant' && variantSelect) {
                    variantSelect.value = prop[1] || '';
                    // Update price display and toggle form fields when loading existing data
                    setTimeout(function() {
                      updateVariantPrice();
                      toggleFormFieldsBasedOnVariant();
                    }, 50);
                  }
                });
              } else if (typeof item.properties === 'object') {
                // Handle as object
                if (item.properties['Receiver Name'] && receiverNameInput) {
                  receiverNameInput.value = item.properties['Receiver Name'] || '';
                }
                if (item.properties['Sender Name'] && senderNameInput) {
                  senderNameInput.value = item.properties['Sender Name'] || '';
                }
                if (item.properties['Message'] && messageTextarea) {
                  messageTextarea.value = item.properties['Message'] || '';
                }
                 if (item.properties['Gift Wrap Variant'] && variantSelect) {
                   variantSelect.value = item.properties['Gift Wrap Variant'] || '';
                   // Update price display and toggle form fields when loading existing data
                   setTimeout(function() {
                     updateVariantPrice();
                     toggleFormFieldsBasedOnVariant();
                   }, 50);
                 }
              }
            }
          })
          .catch(error => {
            console.error('Error loading cart data:', error);
          });
      }
  
      /**
       * Close modal
       */
      function closeModal() {
        if (!modal) return;
        
        modal.classList.remove('active');
        modal.style.display = 'none';
        document.body.style.overflow = '';
  
        // Reset form
        const form = document.getElementById('gift-wrap-form');
        if (form) {
          form.reset();
        }
  
        // Reset variant price display
        const variantPriceEl = document.getElementById('gift-wrap-variant-price');
        if (variantPriceEl) {
          variantPriceEl.style.display = 'none';
        }
  
        // Uncheck checkbox if modal was closed without saving
        if (currentItemKey) {
          const checkbox = document.querySelector('[data-item-key="' + currentItemKey + '"].gift-wrap-checkbox');
          if (checkbox && !checkbox.hasAttribute('data-saved')) {
            checkbox.checked = false;
          }
          if (checkbox) {
            checkbox.removeAttribute('data-saved');
          }
        }
  
        currentItemKey = null;
        currentProductId = null;
        currentVariantId = null;
      }
  
      /**
       * Save gift wrap details
       */
      function saveGiftWrapDetails() {
        // Check if we have at least one identifier (key, product ID, or variant ID)
        if (!currentItemKey && !currentProductId && !currentVariantId) {
          console.error('No item identifier available. Cannot save gift wrap details.');
          return;
        }
  
        const variantSelect = document.getElementById('gift-wrap-variant-select');
        const receiverNameInput = document.getElementById('gift-wrap-receiver-name');
        const senderNameInput = document.getElementById('gift-wrap-sender-name');
        const messageTextarea = document.getElementById('gift-wrap-message');
        const saveBtn = document.querySelector('.gift-wrap-save-btn');
        const saveText = document.querySelector('.gift-wrap-save-text');
        const loadingText = document.querySelector('.gift-wrap-loading');
  
        const selectedVariant = variantSelect ? variantSelect.value : '';
        const receiverName = receiverNameInput ? receiverNameInput.value.trim() : '';
        const senderName = senderNameInput ? senderNameInput.value.trim() : '';
        const message = messageTextarea ? messageTextarea.value.trim() : '';
  
        // Validation
        if (!selectedVariant) {
          console.log('Please select a gift wrap variant');
          return;
        }
  
        // Check if selected variant is "Gift Wrap" only (without message)
        let isGiftWrapOnly = false;
        if (variantSelect) {
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          if (selectedOption) {
            const variantTitle = selectedOption.textContent || '';
            isGiftWrapOnly = variantTitle.toLowerCase().includes('gift wrap') && 
                            !variantTitle.toLowerCase().includes('message');
          }
        }
  
        // Only validate receiver and sender names if not "Gift Wrap" only variant
        if (!isGiftWrapOnly) {
          if (!receiverName) {
            console.log('Please enter receiver\'s name');
            return;
          }
  
          if (!senderName) {
            console.log('Please enter sender\'s name');
            return;
          }
        }
  
        // Show loading state
        if (saveBtn) saveBtn.disabled = true;
        if (saveText) saveText.style.display = 'none';
        if (loadingText) loadingText.style.display = 'inline';
  
        // Get current cart to find the line item ID
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('Searching for cart item. Key:', currentItemKey, 'Product ID:', currentProductId, 'Variant ID:', currentVariantId);
            console.log('Cart items:', cart.items.length);
            
            let item = null;
            
            // Strategy 1: Find by exact key match
            if (currentItemKey) {
              item = cart.items.find(function(cartItem) {
                return cartItem.key === currentItemKey;
              });
              if (item) {
                console.log('Found item by key:', currentItemKey);
              }
            }
  
            // Strategy 2: Find by product ID and variant ID (stored when modal opened)
            if (!item && currentProductId && currentVariantId) {
              item = cart.items.find(function(cartItem) {
                return String(cartItem.product_id) === String(currentProductId) && 
                       String(cartItem.variant_id) === String(currentVariantId);
              });
              if (item) {
                console.log('Found item by product/variant ID. Updating key from', currentItemKey, 'to', item.key);
                currentItemKey = item.key;
              }
            }
            
            // Strategy 3: Find by product ID only (if variant ID doesn't match)
            if (!item && currentProductId) {
              item = cart.items.find(function(cartItem) {
                return String(cartItem.product_id) === String(currentProductId);
              });
              if (item) {
                console.log('Found item by product ID only. Updating key from', currentItemKey, 'to', item.key);
                currentItemKey = item.key;
              }
            }
            
            // Strategy 4: Find by checkbox attributes from DOM
            if (!item) {
              // Try to find checkbox by any available identifier
              let checkbox = null;
              if (currentItemKey) {
                checkbox = document.querySelector('[data-item-key="' + currentItemKey + '"]');
              }
              
              // If not found, try to find by product/variant ID attributes
              if (!checkbox && currentProductId && currentVariantId) {
                checkbox = document.querySelector('[data-product-id="' + currentProductId + '"][data-variant-id="' + currentVariantId + '"]');
              }
              
              if (checkbox) {
                const productId = checkbox.getAttribute('data-product-id');
                const variantId = checkbox.getAttribute('data-variant-id');
                
                if (productId && variantId) {
                  item = cart.items.find(function(cartItem) {
                    return String(cartItem.product_id) === String(productId) && 
                           String(cartItem.variant_id) === String(variantId);
                  });
                  if (item) {
                    console.log('Found item by checkbox DOM attributes. Updating key from', currentItemKey, 'to', item.key);
                    currentItemKey = item.key;
                  }
                }
              }
            }
  
            // Strategy 5: Find by index position (last resort - only if we have a checkbox)
            if (!item && currentItemKey) {
              const checkbox = document.querySelector('[data-item-key="' + currentItemKey + '"]');
              if (checkbox) {
                const allCheckboxes = Array.from(document.querySelectorAll('[data-item-key]'));
                const itemIndex = allCheckboxes.indexOf(checkbox);
                if (itemIndex >= 0 && itemIndex < cart.items.length) {
                  item = cart.items[itemIndex];
                  if (item && item.key) {
                    console.log('Found item by index position. Updating key from', currentItemKey, 'to', item.key);
                    currentItemKey = item.key;
                  }
                }
              }
            }
  
            if (!item) {
              console.error('Cart item not found with key:', currentItemKey);
              console.error('Product ID:', currentProductId, 'Variant ID:', currentVariantId);
              console.log('Available cart items:', cart.items.map(i => ({ key: i.key, product_id: i.product_id, variant_id: i.variant_id })));
              
              // Instead of throwing an error, show a user-friendly message and close the modal
              if (saveBtn) saveBtn.disabled = false;
              if (saveText) saveText.style.display = 'inline';
              if (loadingText) loadingText.style.display = 'none';
              
              // Show error message to user
              alert('The cart item was not found. This may happen if the cart was updated. Please refresh the page and try again.');
              
              // Close modal
              closeModal();
              
              // Refresh the cart to sync with server
              refreshCartHTML();
              
              return; // Exit early instead of throwing error
            }
  
            // Prepare properties object
            const properties = {};
            
            // Get existing properties and merge
            if (item.properties) {
              // Handle properties as array or object
              if (Array.isArray(item.properties)) {
                item.properties.forEach(function(prop) {
                  // Skip gift wrap properties to avoid duplicates
                  if (prop[0] !== 'Gift Wrap Variant ID' && 
                      prop[0] !== 'Gift Wrap Variant' && 
                      prop[0] !== 'Receiver Name' && 
                      prop[0] !== 'Sender Name' && 
                      prop[0] !== 'Message' &&
                      prop[1] !== '' && 
                      prop[1] !== null) {
                    properties[prop[0]] = prop[1];
                  }
                });
              } else if (typeof item.properties === 'object') {
                // Handle as object
                Object.keys(item.properties).forEach(function(key) {
                  // Skip gift wrap properties to avoid duplicates
                  if (key !== 'Gift Wrap Variant ID' && 
                      key !== 'Gift Wrap Variant' && 
                      key !== 'Receiver Name' && 
                      key !== 'Sender Name' && 
                      key !== 'Message') {
                    properties[key] = item.properties[key];
                  }
                });
              }
            }
  
            // Add gift wrap properties to original item (receiver, sender, message)
            // Note: We don't store variant ID here anymore, it's added as a separate cart item
            properties['Receiver Name'] = receiverName;
            properties['Sender Name'] = senderName;
            if (message) {
              properties['Message'] = message;
            }
            // Store the gift wrap variant ID as a property to track which variant is used
            properties['Gift Wrap Variant ID'] = selectedVariant;
            
            // Also store the variant name for display purposes
            if (variantSelect && variantSelect.value) {
              const selectedOption = variantSelect.options[variantSelect.selectedIndex];
              if (selectedOption && selectedOption.textContent) {
                properties['Gift Wrap Variant'] = selectedOption.textContent;
              }
            }
  
            // First, update the original cart item with properties
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: item.key,
                properties: properties
              })
            }).then(response => {
              // Check if response is ok
              if (!response.ok) {
                return response.text().then(text => {
                  console.error('Cart update failed:', response.status, text);
                  throw new Error('Cart update failed: ' + response.status);
                });
              }
              return response.json();
            });
          })
          .then(function(cartOrItem) {
            // Shopify /cart/change.js returns the full cart; ensure we have cart shape
            var cart = cartOrItem;
            if (!cart || !cart.items || !Array.isArray(cart.items)) {
              return fetch('/cart.js')
                .then(response => response.json())
                .then(freshCart => {
                  if (!freshCart || !freshCart.items || !Array.isArray(freshCart.items)) {
                    throw new Error('Failed to get valid cart data');
                  }
                  return freshCart;
                });
            }
            
            // Now add the gift wrap variant as a separate cart item
            // Check if this variant already exists in cart
            const existingGiftWrapItem = cart.items.find(function(cartItem) {
              // Check if this is a gift wrap item (from the gift wrap product)
              // and has the same variant ID
              return cartItem.variant_id == selectedVariant && 
                     cartItem.product_id == giftWrapProductId;
            });
  
            if (existingGiftWrapItem) {
              // Update quantity of existing gift wrap item
              console.log('Gift wrap variant already in cart, updating quantity');
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: existingGiftWrapItem.key,
                  quantity: existingGiftWrapItem.quantity + 1
                })
              }).then(response => {
                // Check if response is ok
                if (!response.ok) {
                  return response.text().then(text => {
                    console.error('Cart quantity update failed:', response.status, text);
                    // If update fails, try to fetch fresh cart
                    return fetch('/cart.js').then(r => r.json());
                  });
                }
                return response.json();
              }).then(updatedCart => {
                // Validate cart object
                if (!updatedCart || !updatedCart.items || !Array.isArray(updatedCart.items)) {
                  // Fetch fresh cart data as fallback
                  return fetch('/cart.js').then(response => response.json());
                }
                return updatedCart;
              });
            } else {
              // Add new gift wrap item to cart
              console.log('Adding new gift wrap variant to cart');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: selectedVariant,
                  quantity: 1
                })
              }).then(response => {
                // Check if response is ok
                if (!response.ok) {
                  return response.text().then(text => {
                    console.error('Cart add failed:', response.status, text);
                    // If add fails, try to fetch fresh cart
                    return fetch('/cart.js').then(r => r.json());
                  });
                }
                return response.json();
              }).then(function(item) {
                // Fetch updated cart
                return fetch('/cart.js')
                  .then(response => response.json())
                  .then(freshCart => {
                    // Validate cart object
                    if (!freshCart || !freshCart.items || !Array.isArray(freshCart.items)) {
                      throw new Error('Failed to get valid cart data after adding item');
                    }
                    return freshCart;
                  });
              });
            }
          })
          .then(cart => {
            // Validate cart object before proceeding
            if (!cart || !cart.items || !Array.isArray(cart.items)) {
              console.error('Invalid cart data received:', cart);
              throw new Error('Invalid cart data received');
            }
            
            // Update cart display
            updateCartDisplay(cart);
            
            // Store the gift wrap details before closing modal
            const variantSelect = document.getElementById('gift-wrap-variant-select');
            const receiverNameInput = document.getElementById('gift-wrap-receiver-name');
            const senderNameInput = document.getElementById('gift-wrap-sender-name');
            const messageTextarea = document.getElementById('gift-wrap-message');
            
            // Store details for after cart refresh
            const savedDetails = {
              itemKey: currentItemKey,
              variant: variantSelect && variantSelect.value ? variantSelect.options[variantSelect.selectedIndex].textContent : '',
              receiverName: receiverNameInput ? receiverNameInput.value : '',
              senderName: senderNameInput ? senderNameInput.value : '',
              message: messageTextarea ? messageTextarea.value : ''
            };
            
            // Mark checkbox as saved
            const checkbox = document.querySelector('[data-item-key="' + currentItemKey + '"].gift-wrap-checkbox');
            if (checkbox) {
              checkbox.setAttribute('data-saved', 'true');
            }
  
            // Update gift wrap total with all gift wrap items
            updateGiftWrapTotal(cart);
  
            // Close modal
            closeModal();
  
            // Refresh cart HTML without full page reload; return so chain doesn't reject on refresh failure
            return refreshCartHTML().then(function() {
              // After cart refresh, update gift wrap details display
              const detailsDiv = document.querySelector('.gift-wrap-details[data-item-key="' + savedDetails.itemKey + '"]');
              if (detailsDiv) {
                let detailsHTML = '';
                if (savedDetails.variant) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Gift Option:</strong> ' + savedDetails.variant + '</p>';
                }
                if (savedDetails.receiverName) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Receiver name:</strong> ' + savedDetails.receiverName + '</p>';
                }
                if (savedDetails.senderName) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Sender name:</strong> ' + savedDetails.senderName + '</p>';
                }
                if (savedDetails.message) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Message:</strong> ' + savedDetails.message + '</p>';
                }
                
                if (detailsHTML) {
                  detailsDiv.innerHTML = detailsHTML;
                  detailsDiv.style.display = 'block';
                }
              }
              
              // Re-mark checkbox as saved after refresh
              const refreshedCheckbox = document.querySelector('[data-item-key="' + savedDetails.itemKey + '"].gift-wrap-checkbox');
              if (refreshedCheckbox) {
                refreshedCheckbox.setAttribute('data-saved', 'true');
                refreshedCheckbox.checked = true;
              }
            }).catch(function(error) {
              console.error('Error refreshing cart:', error);
              // Fallback: if refresh fails, show details anyway (gift wrap was still added)
              const detailsDiv = document.querySelector('.gift-wrap-details[data-item-key="' + savedDetails.itemKey + '"]');
              if (detailsDiv) {
                let detailsHTML = '';
                if (savedDetails.variant) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Gift Option:</strong> ' + savedDetails.variant + '</p>';
                }
                if (savedDetails.receiverName) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Receiver name:</strong> ' + savedDetails.receiverName + '</p>';
                }
                if (savedDetails.senderName) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Sender name:</strong> ' + savedDetails.senderName + '</p>';
                }
                if (savedDetails.message) {
                  detailsHTML += '<p class="gift-wrap-info"><strong>Message:</strong> ' + savedDetails.message + '</p>';
                }
                
                if (detailsHTML) { 
                  detailsDiv.innerHTML = detailsHTML;
                  detailsDiv.style.display = 'block';
                }
              }
            });
          })
          .catch(error => {
            console.error('Error updating cart:', error);
            
            // Restore button state
            if (saveBtn) saveBtn.disabled = false;
            if (saveText) saveText.style.display = 'inline';
            if (loadingText) loadingText.style.display = 'none';
            
            // Don't show alert for "Cart item not found" or for cart/refresh errors that can happen after a successful add
            var msg = (error && error.message) ? error.message : '';
            var isCartItemNotFound = msg.includes('Cart item not found');
            var isPostAddCartError = msg.includes('Invalid cart data') || msg.includes('Failed to get valid cart data');
            if (msg && !isCartItemNotFound && !isPostAddCartError) {
              alert('Failed to save gift wrap details. Please try again.');
            }
          })
          .finally(function() {
            // Restore button state
            if (saveBtn) saveBtn.disabled = false;
            if (saveText) saveText.style.display = 'inline';
            if (loadingText) loadingText.style.display = 'none';
          });
      }
  
      /**
       * Remove gift wrap from item
       */
      function removeGiftWrap(itemKey, productIdAttr, variantIdAttr) {
        if (!giftWrapProductId) {
          initializeGiftWrapProductId();
        }

        return fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            var item = cart.items.find(function(cartItem) {
              return String(cartItem.key) === String(itemKey);
            });

            if (!item) {
              var hasGiftWrapInCart = false;
              cart.items.forEach(function(cartItem) {
                if (cartItem.properties) {
                  if (Array.isArray(cartItem.properties)) {
                    var hasGiftWrap = cartItem.properties.some(function(prop) {
                      return (prop[0] === 'Gift Wrap Variant ID' && prop[1] && prop[1] !== '' && prop[1] !== null) ||
                             (prop[0] === 'Gift Wrap Variant' && prop[1] && prop[1] !== '' && prop[1] !== null);
                    });
                    if (hasGiftWrap) hasGiftWrapInCart = true;
                  } else if (typeof cartItem.properties === 'object') {
                    if ((cartItem.properties['Gift Wrap Variant ID'] && cartItem.properties['Gift Wrap Variant ID'] !== '' && cartItem.properties['Gift Wrap Variant ID'] !== null) ||
                        (cartItem.properties['Gift Wrap Variant'] && cartItem.properties['Gift Wrap Variant'] !== '' && cartItem.properties['Gift Wrap Variant'] !== null)) {
                      hasGiftWrapInCart = true;
                    }
                  }
                }
              });

              if (!hasGiftWrapInCart) {
                return Promise.resolve(cart);
              }

              var productIdNum = productIdAttr != null && productIdAttr !== '' ? parseInt(productIdAttr, 10) : null;
              var variantIdNum = variantIdAttr != null && variantIdAttr !== '' ? parseInt(variantIdAttr, 10) : null;
              item = cart.items.find(function(cartItem) {
                if (cartItem.product_id == giftWrapProductId) return false;
                var hasGift = false;
                if (cartItem.properties) {
                  if (Array.isArray(cartItem.properties)) {
                    hasGift = cartItem.properties.some(function(prop) {
                      return (prop[0] === 'Gift Wrap Variant ID' && prop[1] && prop[1] !== '' && prop[1] !== null);
                    });
                  } else if (cartItem.properties['Gift Wrap Variant ID'] && cartItem.properties['Gift Wrap Variant ID'] !== '' && cartItem.properties['Gift Wrap Variant ID'] !== null) {
                    hasGift = true;
                  }
                }
                if (!hasGift) return false;
                if (productIdNum != null && String(cartItem.product_id) !== String(productIdNum)) return false;
                if (variantIdNum != null && String(cartItem.variant_id) !== String(variantIdNum)) return false;
                return true;
              });

              if (!item) {
                return Promise.resolve(cart);
              }
            }
  
            // Extract gift wrap variant ID first (needed to remove the gift wrap line item later)
            var giftWrapKeys = ['Gift Wrap Variant ID', 'Gift Wrap Variant', 'Receiver Name', 'Sender Name', 'Message'];
            var giftWrapVariantId = null;
            var newProperties = {};
            if (item.properties) {
              if (Array.isArray(item.properties)) {
                item.properties.forEach(function(prop) {
                  var k = prop[0], v = prop[1];
                  if (k === 'Gift Wrap Variant ID') giftWrapVariantId = v;
                  if (giftWrapKeys.indexOf(k) === -1 && v != null && v !== '') newProperties[k] = v;
                });
              } else if (typeof item.properties === 'object') {
                Object.keys(item.properties).forEach(function(k) {
                  var v = item.properties[k];
                  if (k === 'Gift Wrap Variant ID') giftWrapVariantId = v;
                  if (giftWrapKeys.indexOf(k) === -1 && v != null && v !== '') newProperties[k] = v;
                });
              }
            }
            // Shopify replaces the entire properties object; empty object can be ignored, so use placeholder if clearing all
            if (Object.keys(newProperties).length === 0) newProperties['_'] = '1';

            var updateData = {
              id: item.key,
              quantity: item.quantity,
              properties: newProperties
            };

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(updateData)
            }).then(function(response) {
              if (!response.ok) {
                throw new Error('Failed to update cart item: ' + response.status + ' ' + response.statusText);
              }
              return response.json();
            }).then(function(cart) {
              // Now find and remove/decrease quantity of the gift wrap item
              if (giftWrapVariantId) {
                // Find gift wrap item with this variant ID
                const gwProductId = giftWrapProductId != null ? String(giftWrapProductId) : null;
                const giftWrapItem = cart.items.find(function(cartItem) {
                  if (String(cartItem.variant_id) !== String(giftWrapVariantId)) return false;
                  if (gwProductId) return String(cartItem.product_id) === gwProductId;
                  return true;
                });
  
                if (giftWrapItem) {
                  if (giftWrapItem.quantity > 1) {
                    // Decrease quantity
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        id: giftWrapItem.key,
                        quantity: giftWrapItem.quantity - 1
                      })
                    }).then(function(response) {
                      if (!response.ok) {
                        console.warn('Failed to decrease gift wrap quantity, but continuing...');
                        return cart; // Return original cart if this fails
                      }
                      return response.json();
                    }).catch(function(error) {
                      console.warn('Error decreasing gift wrap quantity:', error);
                      return cart; // Return original cart if this fails
                    });
                  } else {
                    // Remove item completely
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        id: giftWrapItem.key,
                        quantity: 0
                      })
                    }).then(function(response) {
                      if (!response.ok) {
                        console.warn('Failed to remove gift wrap item, but continuing...');
                        return cart; // Return original cart if this fails
                      }
                      return response.json();
                    }).catch(function(error) {
                      console.warn('Error removing gift wrap item:', error);
                      return cart; // Return original cart if this fails
                    });
                  }
                }
              }
              return cart;
            }).catch(function(error) {
              console.error('Error in cart update:', error);
              // Even if cart update fails, try to continue with property removal
              // Re-fetch cart to get current state
              return fetch('/cart.js').then(function(response) {
                if (!response.ok) {
                  throw new Error('Failed to fetch cart: ' + response.status);
                }
                return response.json();
              }).catch(function(fetchError) {
                console.error('Failed to fetch cart after error:', fetchError);
                throw error; // Re-throw original error
              });
            });
          })
          .then(cart => {
            // All properties have been cleared - no need to verify
            // Just proceed to remove gift wrap item and refresh
            return cart;
          })
          .then(cart => {
            // Update cart display
            updateCartDisplay(cart);
            
            // Hide gift wrap details
            const detailsDiv = document.querySelector('.gift-wrap-details[data-item-key="' + itemKey + '"]');
            if (detailsDiv) {
              detailsDiv.style.display = 'none';
              detailsDiv.innerHTML = '';
            }
            
            // Update gift wrap total first (before unchecking checkbox)
            updateGiftWrapTotal(cart);
            
            // Uncheck the checkbox - do NOT dispatch 'change' (would re-trigger removeGiftWrap and cause infinite loop)
            const checkbox = document.querySelector('[data-item-key="' + itemKey + '"].gift-wrap-checkbox');
            if (checkbox) {
              checkbox.checked = false;
              checkbox.removeAttribute('checked');
              checkbox.removeAttribute('data-saved');
              if (checkbox.parentNode) {
                checkbox.parentNode.classList.remove('checked');
              }
            }
            
            // Refresh cart HTML so UI matches cart state
            return refreshCartHTML();
          })
          .catch(error => {
            console.error('Error removing gift wrap:', error);
            console.error('Error details:', error.message, error.stack);
            
            // Force uncheck checkbox even on error
            const checkbox = document.querySelector('[data-item-key="' + itemKey + '"].gift-wrap-checkbox');
            if (checkbox) {
              checkbox.checked = false;
              checkbox.removeAttribute('checked');
              checkbox.removeAttribute('data-saved');
            }
            
            // Hide gift wrap details
            const detailsDiv = document.querySelector('.gift-wrap-details[data-item-key="' + itemKey + '"]');
            if (detailsDiv) {
              detailsDiv.style.display = 'none';
              detailsDiv.innerHTML = '';
            }
            
            refreshCartHTML();
          });
      }
  
    /**
     * Refresh cart HTML without page reload
     * Similar to how the theme's CartSection._rerenderCart works
     */
    function refreshCartHTML() {
      // Prevent multiple simultaneous refreshes
      if (isRefreshingCart) {
        console.log('Cart refresh already in progress, skipping...');
        return Promise.resolve();
      }
      
      // Set flag to prevent concurrent refreshes
      isRefreshingCart = true;
      
      // Show loading state
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      
      // Fetch updated cart HTML
      return fetch('/cart?view=ajax&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart HTML: ' + response.status);
        }
        return response.text();
      })
      .then(function(html) {
        // Create a temporary container to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // On cart page: scope to main cart section to avoid replacing the wrong container (e.g. cart drawer)
        var path = (typeof window !== 'undefined' && window.location) ? window.location.pathname : '';
        var isCartPage = path === '/cart' || path.endsWith('/cart');
        var scope = document;
        var tempScope = tempDiv;
        if (isCartPage) {
          var cartSection = document.querySelector('[data-section-type="cart"]');
          var fetchedCartSection = tempDiv.querySelector('[data-section-type="cart"]');
          if (cartSection) scope = cartSection;
          if (fetchedCartSection) tempScope = fetchedCartSection;
        }
        
        const cartItemsContainer = scope.querySelector('.Cart__ItemList, .CartItems, .Cart__ItemList_Main');
        const newCartItems = tempScope.querySelector('.Cart__ItemList, .CartItems, .Cart__ItemList_Main');
        
        if (cartItemsContainer && newCartItems && newCartItems.innerHTML && html) {
          cartItemsContainer.innerHTML = newCartItems.innerHTML;
        }
        
        // Update cart footer if it exists
        const cartFooter = document.querySelector('.Cart__Footer');
        const newCartFooter = tempDiv.querySelector('.Cart__Footer');
        if (cartFooter && newCartFooter) {
          cartFooter.innerHTML = newCartFooter.innerHTML;
        }
        
        // Update cart totals
        const cartTotal = document.querySelector('.Cart__Total, .Cart__TotalPrice');
        const newCartTotal = tempDiv.querySelector('.Cart__Total, .Cart__TotalPrice');
        if (cartTotal && newCartTotal) {
          cartTotal.innerHTML = newCartTotal.innerHTML;
        }
        
        // Update cart count in header
        const cartCountEl = tempDiv.querySelector('.Header__CartCount, .hw--Header__CartCount');
        if (cartCountEl) {
          const currentCartCount = document.querySelector('.Header__CartCount, .hw--Header__CartCount');
          if (currentCartCount) {
            currentCartCount.textContent = cartCountEl.textContent;
          }
        }
        
        // Hide loading state
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        
        // Re-initialize gift wrap after cart refresh (debounced to prevent multiple calls)
        if (window.giftWrapRefreshTimeout) {
          clearTimeout(window.giftWrapRefreshTimeout);
        }
        
        window.giftWrapRefreshTimeout = setTimeout(function() {
          initializeGiftWrapProductId();
          initGiftWrap();
          
          // Update gift wrap total without triggering cart:updated event
          // (to prevent infinite loop)
          return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              updateGiftWrapTotal(cart);
              // Don't dispatch cart:updated event here to prevent infinite loop
              // The cart is already updated, we just need to sync the UI
            })
            .catch(function(error) {
              console.error('Error updating gift wrap after refresh:', error);
            })
            .finally(function() {
              // Reset refresh flag after a short delay
              setTimeout(function() {
                isRefreshingCart = false;
              }, 500);
            });
        }, 300);
      })
      .catch(function(error) {
        console.error('Error refreshing cart HTML:', error);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        isRefreshingCart = false;
        // Don't reload - cart state is still correct; user can refresh manually if needed
      });
    }
  
    /**
     * Update cart display
     */
    function updateCartDisplay(cart) {
        // Update cart count if element exists
        const cartCountEl = document.querySelector('.Header__CartCount, .hw--Header__CartCount');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }
  
        // Update cart totals
        const totalElements = document.querySelectorAll('[data-money-convertible]');
        totalElements.forEach(function(el) {
          // This will be handled by the theme's money conversion if available
        });
  
        // Trigger custom event for other scripts
        const event = new CustomEvent('cart:updated', { detail: cart });
        document.dispatchEvent(event);
      }
  
  }
  })();
  
  